module.exports = __webpack_public_path__ + "img/pelmenya_logo.2ff1abeb.svg";